import { render, staticRenderFns } from "./VariablesPage.vue?vue&type=template&id=4ff8d065&scoped=true"
import script from "./VariablesPage.vue?vue&type=script&lang=js"
export * from "./VariablesPage.vue?vue&type=script&lang=js"
import style0 from "./VariablesPage.vue?vue&type=style&index=0&id=4ff8d065&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff8d065",
  null
  
)

export default component.exports